import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type ProductCatalogue = {
    additionalColumnValues: Record<Uuid, unknown>;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    id: Uuid;
    parentId: Uuid | null;
    status: ProductCatalogueStatus;
    templateId: Uuid;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    workspaceId: Uuid;
};

export enum ProductCatalogueStatus {
    active = "f39cd914-b2c4-476f-8be4-6fffecb4f812",
    archived = "073578be-c5fc-40e5-a5bc-ae414643f3ca",
    deleted = "d60584ac-ab17-418b-a807-b3cee0b1f806",
}

export const productCatalogueValidator: zod.ZodType<ProductCatalogue> = zod.object({
    additionalColumnValues: zod.record(uuidZodValidator, zod.unknown()),
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    id: uuidZodValidator,
    parentId: uuidZodValidator.nullable(),
    status: zod.enum(ProductCatalogueStatus),
    templateId: uuidZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
